<div class="bread-crumb-container space">
    <h2 class="margin-0">Teams Meetings Sync</h2>
</div>
<div class="global-container" [ngStyle]="{'overflow':'auto'}">
  <div class="container-fluid">
  <div class="adc-mb10 space">
    <mat-form-field appearance="outline" class="date date-range">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Start date" #dateRangeStart [readonly]="true" (focus)="picker.open()" (click)="picker.open()">
        <input matEndDate placeholder="End date" #dateRangeEnd [readonly]="true" (focus)="picker.open()" (click)="picker.open()" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
      </mat-date-range-input>
      <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>
  <div *ngIf="meetings?.length; else empty">
    <div class="mat-elevation-z2">
      <table mat-table [dataSource]="dataSource" class="full-width" matSort>

        <!-- Title Column -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-container"> Title </th>
          <td mat-cell *matCellDef="let m"> {{ m.title }} </td>
        </ng-container>

        <!-- Start Column -->
        <ng-container matColumnDef="start">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-container"> Start </th>
          <td mat-cell *matCellDef="let m"> {{ m.start }} </td>
        </ng-container>

        <!-- Organizer Column -->
        <ng-container matColumnDef="organizer">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-container"> Organizer </th>
          <td mat-cell *matCellDef="let m"> {{ m.organizer || '-' }} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="actions-col" class="header-container"> Actions </th>
          <td mat-cell *matCellDef="let m" class="actions-col">
            <button mat-icon-button color="primary" (click)="onSync(m)" matTooltip="Sync this meeting">
              <mat-icon>sync</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <ng-template #empty>
    <div class="empty">No Teams meetings to display.</div>
  </ng-template>
</div>
</div>
